import _classCallCheck from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/classCallCheck";
import _createClass from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/createClass";

var MiscHelper =
/*#__PURE__*/
function () {
  function MiscHelper() {
    _classCallCheck(this, MiscHelper);
  }

  _createClass(MiscHelper, [{
    key: "Clone",
    value: function Clone(obj) {
      return JSON.parse(JSON.stringify(obj));
    }
  }]);

  return MiscHelper;
}();

export default new MiscHelper();